module.exports = __webpack_public_path__ + "img/Icon_Optimieren.17ffc13b.svg";